<template>
  <div class="reward-container">
    <!-- 返回按钮（浏览器自带返回键同样可用，这里提供页面内入口） -->
    <el-button class="back-btn" text @click="goBack">
      <el-icon><ArrowLeft /></el-icon>
      返回
    </el-button>
    <el-card shadow="hover" class="reward-card">
      <template #header>
        <div class="card-header">
          <span>打赏支持</span>
          <el-icon><coffee /></el-icon>
        </div>
      </template>

      <!-- 表单 -->
      <el-form
        ref="formRef"
        :model="encourage"
        label-width="80px"
        class="reward-form"
      >
        <!-- 金额选择 -->
        <el-form-item label="打赏金额" prop="amount" rules="[{ required: true, message: '请选择打赏金额', trigger: 'change' }]">
          <div class="amount-list">
            <div
              v-for="item in amountOptions"
              :key="item.value"
              class="amount-item"
              :class="{ active: encourage.amount === item.value }"
              @click="encourage.amount = item.value"
            >
              {{ item.label }}
            </div>
          </div>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="encourage.remark"
            type="textarea"
            :rows="3"
            placeholder="写下留言（选填，最多100字）"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" size="large" @click="handleSubmit" :loading="submitLoading">
            确认打赏 {{ encourage.amount ? encourage.amount + '元' : '' }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref,onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Coffee, ArrowLeft } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { useDisableDevTools } from "@/composables/useDisableDevTools";

// 保存开发者工具禁用清理函数
let cleanupDevTools = null

// 表单对象【名称固定：encourage】传给后端
const encourage = ref({
  amount: '', // 打赏金额
  remark: ''  // 备注信息
})

// 表单实例
const formRef = ref(null)
const submitLoading = ref(false)

// 路由：用于返回上一页
const router = useRouter()

// 返回上一页：优先使用浏览器历史回退（与阅读页/章节目录页写法保持一致），
// 若是直接打开本页（没有上一页）则兜底回首页
const goBack = () => {
  if (window.history.length > 1) router.back()
  else router.push({ name: 'homepage' })
}

// 金额选项列表
const amountOptions = ref([
  { label: '1元', value: 1 },
  { label: '3元', value: 3 },
  { label: '5元', value: 5 },
  { label: '10元', value: 10 },
  { label: '50元', value: 50 },
  { label: '100元', value: 100 }
])
onMounted(() => {
  // 默认选中第一个金额选项
  useDisableDevTools()
})
// 表单提交函数（预留后端接口）
const handleSubmit = async () => {
  // 表单校验
  await formRef.value.validate((valid) => {
    if (!valid) return
  })

  submitLoading.value = true
  try {
    // ========== 后端请求预留位置 ==========
    // const res = await axios.post('/api/reward', encourage.value)
    // 传递的数据就是 encourage: { amount, remark }
    console.log('提交给后端的数据：', encourage.value)
    ElMessage.success('打赏信息提交成功，等待支付')
  } catch (err) {
    console.error('提交失败', err)
    ElMessage.error('提交失败，请重试')
  } finally {
    submitLoading.value = false
  }
}
</script>

<style scoped>
.reward-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
}
.reward-card {
  width: 520px;
}
.card-header {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.amount-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.amount-item {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
}
.amount-item:hover {
  border-color: #409eff;
}
.amount-item.active {
  background-color: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
  font-weight: 600;
}
.reward-form {
  margin-top: 10px;
}
.back-btn {
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 10;
}
</style>